// extracted by mini-css-extract-plugin
module.exports = {"h1Class":"index-module--h1-class--vWRfN","buttons":"index-module--buttons--3dLIt"};